export const hotSearchBuyData = [
    {
        "id": 1,
        "image": require("../images/hotsearchBuy/buy_01.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_01_330w.webp"),
        "name": "堯平布朗尼",
        "link": "https://www.pixnet.net/ppage/堯平布朗尼"
    },
    {
        "id": 2,
        "image": require("../images/hotsearchBuy/buy_02.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_02_330w.webp"),
        "name": "狸小路手作烘焙",
        "link": "https://www.pixnet.net/ppage/狸小路手作烘焙"
    },
    {
        "id": 3,
        "image": require("../images/hotsearchBuy/buy_03.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_03_330w.webp"),
        "name": "吻鑽糖半熟乳酪塔",
        "link": "https://www.pixnet.net/ppage/吻鑽糖半熟乳酪塔"
    },
    {
        "id": 4,
        "image": require("../images/hotsearchBuy/buy_04.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_04_330w.webp"),
        "name": "方蘭川布丁",
        "link": "https://www.pixnet.net/ppage/方蘭川布丁"
    },
    {
        "id": 5,
        "image": require("../images/hotsearchBuy/buy_05.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_05_330w.webp"),
        "name": "得意蝦餅",
        "link": "https://www.pixnet.net/ppage/得意蝦餅"
    },
    {
        "id": 6,
        "image": require("../images/hotsearchBuy/buy_06.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_06_330w.webp"),
        "name": "葡吉麵包",
        "link": "https://flower033880.pixnet.net/blog/post/232283749"
    },
    {
        "id": 7,
        "image": require("../images/hotsearchBuy/buy_07.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_07_330w.webp"),
        "name": "美格瑪半熟起司",
        "link": "https://satani815.pixnet.net/blog/post/70958815"
    },
    {
        "id": 8,
        "image": require("../images/hotsearchBuy/buy_08.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_08_330w.webp"),
        "name": "O卡桑黑白木耳露養生飲",
        "link": "https://www.pixnet.net/ppage/O卡桑黑白木耳露養生飲"
    },
    {
        "id": 9,
        "image": require("../images/hotsearchBuy/buy_09.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_09_330w.webp"),
        "name": "甜蜜點 日式貝果",
        "link": "https://flower033880.pixnet.net/blog/post/231325165"
    },
    {
        "id": 10,
        "image": require("../images/hotsearchBuy/buy_10.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_10_330w.webp"),
        "name": "林永泰興蜜餞",
        "link": "https://eeooa0314.pixnet.net/blog/post/563085778"
    },
    {
        "id": 11,
        "image": require("../images/hotsearchBuy/buy_11.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_11_330w.webp"),
        "name": "阿麗阿珍大灣花生糖",
        "link": "https://ksk.tw/blog/post/354202027"
    },
    {
        "id": 12,
        "image": require("../images/hotsearchBuy/buy_12.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_12_330w.webp"),
        "name": "依蕾特布丁",
        "link": "https://www.pixnet.net/ppage/依蕾特布丁"
    },
    {
        "id": 13,
        "image": require("../images/hotsearchBuy/buy_13.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_13_330w.webp"),
        "name": "金桃家草莓大福",
        "link": "https://www.pixnet.net/ppage/金桃家草莓大福"
    },
    {
        "id": 14,
        "image": require("../images/hotsearchBuy/buy_14.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_14_330w.webp"),
        "name": "紅磚布丁",
        "link": "https://www.pixnet.net/ppage/紅磚布丁"
    },
    {
        "id": 15,
        "image": require("../images/hotsearchBuy/buy_15.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_15_330w.webp"),
        "name": "所長茶葉蛋",
        "link": "https://www.pixnet.net/ppage/所長茶葉蛋"
    },
    {
        "id": 16,
        "image": require("../images/hotsearchBuy/buy_16.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_16_330w.webp"),
        "name": "愛豆屋洋菓子工坊",
        "link": "https://www.pixnet.net/ppage/愛豆屋洋菓子工坊"
    },
    {
        "id": 17,
        "image": require("../images/hotsearchBuy/buy_17.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_17_330w.webp"),
        "name": "連得堂煎餅",
        "link": "https://dong1104.pixnet.net/blog/post/43531319"
    },
    {
        "id": 18,
        "image": require("../images/hotsearchBuy/buy_18.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_18_330w.webp"),
        "name": "豬飼料柑仔店",
        "link": "https://www.pixnet.net/ppage/豬飼料柑仔店"
    },
    {
        "id": 19,
        "image": require("../images/hotsearchBuy/buy_19.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_19_330w.webp"),
        "name": "克林台包",
        "link": "https://www.pixnet.net/ppage/克林台包"
    },
    {
        "id": 20,
        "image": null,
        "imageSmall": null,
        "name": "萬川號餅舖",
        "link": "https://www.pixnet.net/ppage/萬川號餅舖"
    },
    {
        "id": 21,
        "image": require("../images/hotsearchBuy/buy_21.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_21_330w.webp"),
        "name": "日芳珍饌淬魚精",
        "link": "https://www.pixnet.net/ppage/日芳珍饌淬魚精"
    },
    {
        "id": 22,
        "image": require("../images/hotsearchBuy/buy_22.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_22_330w.webp"),
        "name": "小葉布丁",
        "link": "https://little15.pixnet.net/blog/post/48812739"
    },
    {
        "id": 23,
        "image": require("../images/hotsearchBuy/buy_23.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_23_330w.webp"),
        "name": "你我他之家冰鎮滷味",
        "link": "https://ksk.tw/blog/post/327360726"
    },
    {
        "id": 24,
        "image": require("../images/hotsearchBuy/buy_24.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_24_330w.webp"),
        "name": "滋美軒肉鬆",
        "link": "https://michelle19901201.pixnet.net/blog/post/467148980"
    },
    {
        "id": 25,
        "image": require("../images/hotsearchBuy/buy_25.webp"),
        "imageSmall": require("../images/hotsearchBuy/buy_25_330w.webp"),
        "name": "名坂奇洋菓子の店",
        "link": "https://flower033880.pixnet.net/blog/post/229516064"
    }
];
